import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Catalog } from './components/Catalog';
import { About } from './components/About';
import { Authors } from './components/Authors';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-paper" data-id="element-0" data-mp="3f8eyriwexrto">
      <Navbar data-id="element-1" data-mp="2rk46330veygh" />
      <main data-id="element-2" data-mp="2rlozuqfd2dda">
        <Hero data-id="element-3" data-mp="2rlf6csv3xo2u" />
        <Catalog data-id="element-4" data-mp="2rit2b37fdqpd" />
        <About data-id="element-5" data-mp="2mlu9qp3etrta" />
        <Authors data-id="element-6" data-mp="2mmce69087cca" />
        <Contact data-id="element-7" data-mp="2mmvkstkfeeb0" />
      </main>
      <Footer data-id="element-8" data-mp="2mnnic9xl2m3x" />
    </div>;
}